export default __webpack_public_path__ + "static/media/CSRealCase1-en-moblie.79d852c4.jpg";